import React, { useEffect, useState } from "react";
import DataTable from "examples/Tables/DataTable";
import Swal from "sweetalert2";
import Api from "../../api/api";
import { useNavigate } from "react-router-dom";

const BannerTable = ({ refreshTrigger }) => {
  const [userData, setUserData] = useState({ columns: [], rows: [] });
  const navigate = useNavigate();

  const fetchUserData = async () => {
    try {
      const users = await Api.fetchBanner();

      const columns = [
        { Header: "Title", accessor: "title", align: "left" },
        { Header: "Image", accessor: "image", align: "left" },
        { Header: "Status", accessor: "status", align: "center" },
        { Header: "Action", accessor: "action", align: "center" },
      ];

      const rows = users.map((user) => ({
        title: user.title,
        image: (
          <img
            src={`https://iot.papayacoders.in/storage/app/public/${user.image}`}
            alt={user.image}
            style={{
              width: "40px",
              height: "40px",
              objectFit: "cover",
              borderRadius: "8px",
            }}
          />
        ),
        status: (
          <span style={{ color: user.status === 1 ? "green" : "red" }}>
            {user.status === 1 ? "Active" : " Inactive"}
          </span>
        ),
        action: (
          <div style={{ display: "flex", gap: "15px", justifyContent: "center" }}>
            <button
              onClick={() => handleEdit(user)}
              style={{
                color: "#7b809a",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                fontWeight: "500",
              }}
              onMouseOver={(e) => (e.target.style.color = "#007bff")}
              onMouseOut={(e) => (e.target.style.color = "#7b809a")}
            >
              Update
            </button>
            <button
              onClick={() => handleDelete(user.id)}
              style={{
                color: "#dc3545",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                fontWeight: "500",
              }}

            >
              Delete
            </button>
          </div>
        ),
      }));

      setUserData({ columns, rows });
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleEdit = (user) => {
    navigate(`/updatestatus/${user.id}`, { state: user });
  };


  const handleDelete = async (bannerId) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        await Api.deleteBanner(bannerId);
        Swal.fire("Deleted!", "Banner has been deleted.", "success");
        fetchUserData();
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      Swal.fire("Error!", "Failed to delete user.", "error");
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [refreshTrigger]);

  return (
    <>
      <DataTable
        table={userData}
        entriesPerPage={{ defaultValue: 5, entries: [5, 10, 15] }}
        canSearch
        showTotalEntries
        isSorted={false}
      />
    </>
  );
};

export default BannerTable;
